import { useMemo } from 'react';

import { useQuery } from '@apollo/client/react';

import { GET_PROPERTY_TYPES } from '@modules/_shared/common/queries';
import {
  createTransactionPropertyGroupOptions,
  createTransactionPropertyTypeOptions,
} from '@modules/_shared/utils/propertyTypeHelpers';

export const usePropertyTypeOptions = (selectedCompositeType: string) => {
  const { data, loading } = useQuery(GET_PROPERTY_TYPES);

  const mainTypeOptions = useMemo(
    () => createTransactionPropertyGroupOptions(data?.property_types),
    [data],
  );

  const subTypeOptions = useMemo(
    () =>
      createTransactionPropertyTypeOptions(
        data?.property_types,
        selectedCompositeType,
      ),
    [data, selectedCompositeType],
  );

  return {
    mainTypeOptions,
    subTypeOptions,
    loading,
    propertyTypes: data?.property_types,
  };
};
